// Module
var code = "<h4><i class=\"glyphicon glyphicon-globe\"></i> <span ng-transclude></span></h4>";
// Exports
module.exports = code;